import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Root = styled('div')(() => ({
	display: 'flex',
	flexDirection: 'column',
}));

export const Title = styled(Typography)({
	fontFamily: 'Palanquin, sans-serif',
	fontSize: '32px',
	fontWeight: 700,
	lineHeight: '40px',
	color: 'rgb(28, 48, 139)',
	marginBottom: '32px',
	textAlign: 'center',
});

export const Description = styled(Typography)(({ theme }) => ({
	...theme.typography.body2,
	color: theme.palette.neutral[80],
	marginBottom: '24px',
	textAlign: 'center',
}));

export const SubmitLevel = styled('div')(() => ({
	marginTop: '24px',
}));

export const ErrorWrapper = styled('span', {
	shouldForwardProp: (prop) => prop !== 'error',
})<{ error: boolean }>(({ theme, error }) => ({
	display: error ? 'block' : 'none',
	color: theme.palette.error.main,
	...theme.typography.caption,
}));
